export const servicesData = {
  'fda': {
    title: 'FDA Regulatory Compliance',
    subtitle: 'India FDA - State-Level Regulatory Compliance',
    heroImage: 'https://images.pexels.com/photos/19471014/pexels-photo-19471014.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    overviewTitle: 'State-Level FDA Compliance for India',
    overview: 'India\'s drug regulatory framework operates through a dual structure - the Central Drugs Standard Control Organisation (CDSCO) at the national level and State Drug Authorities (FDA/Drug Controllers) at the state level. Compliance with state-level FDA requirements is mandatory for manufacturers, distributors, blood centres, and AYUSH stakeholders across the supply chain.',
    services: [
      {
        title: 'Manufacturing Licence Support',
        description: 'Navigating state FDA compliance can be complex. Our experts help you stay audit-ready.',
        items: [
          'Support to obtain and renew Manufacturing Licence under the Drugs & Cosmetics Act, 1940 & Rules 1945',
          'Support to obtain and renew Blood Centre/Blood Storage Licence under the Drugs & Cosmetics Act, 1940 & Rules 1945',
          'Support to obtain and renew Approved Testing Laboratory/PTL Licence under the Drugs & Cosmetics Act, 1940 & Rules 1945',
          'Periodic inspection preparedness - state FDA conducts scheduled and surprise audits',
          'Tender Certificates in Record Time',
          'Competent Technical Staff Approvals',
          'Additional Product Approvals',
        ],
      },
      {
        title: 'Distribution & Retail Licences',
        items: [
          'Support to obtain Retail / Wholesale Drug Licence / Distribution issued by State Licensing Authority',
          'Periodic inspection preparedness - state FDA conducts scheduled and surprise audits',
        ],
      },
    ],
    whyChoose: [
      'Deep expertise in India state-level FDA compliance',
      'Licence application and renewal support across all categories',
      'Inspection preparedness and audit readiness programs',
    ],
  },
  'cdsco': {
    title: 'CDSCO Regulatory Compliance',
    subtitle: 'Navigating India\'s Pharmaceutical Regulatory Framework',
    heroImage: 'https://images.unsplash.com/photo-1669101283985-ab2b293923df?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1920',
    overviewTitle: 'Central Drugs Standard Control Organisation (CDSCO)',
    overview: 'CDSCO governs the approval of new drugs, cosmetics, biologics, medical devices, Blood centres, Clinical trials and diagnostics in India.',
    services: [
      {
        title: 'New Drug/Device Applications (NDA)',
        items: [
          'New Chemical Entity (NCE) applications',
          'Fixed-Dose Combination (FDC) approvals',
          'Biological / biosimilar applications',
        ],
      },
      {
        title: 'Medical Device & Other Applications',
        items: [
          'Medical Device Applications',
          'NOC Applications',
          'Import registration for drugs and devices',
          'Regulatory representation for foreign manufacturers',
          'Test License for Unapproved API / Formulation',
          'Export NOC for Unapproved API / Formulation',
          'Import Licenses under Test / Commercial License',
          'Dual Use NOC for Excipients',
        ],
      },
      {
        title: 'Clinical Trial Approvals',
        items: [
          'Clinical trial application (CTA) preparation',
          'Ethics committee coordination guidance',
          'IND/BE study submissions to CDSCO',
        ],
      },
    ],
    whyChoose: [
      'Decade-long CDSCO submission experience',
      'Direct relationships with regulatory authorities',
      'Complete understanding of India-specific requirements',
    ],
  },
  'global-regulatory': {
    title: 'Global Regulatory Compliance',
    subtitle: 'Turning Regulatory Complexity into Competitive Advantage',
    heroImage: 'https://images.unsplash.com/photo-1576669801838-1b1c52121e6a?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1920',
    overviewTitle: 'Strategic Global Regulatory Affairs',
    overview: 'In today\'s tightly regulated life sciences environment, regulatory affairs is not merely a back-office function - it is a core business strategy. Getting it right from day one determines how quickly your products reach patients, healthcare professionals, and consumers.',
    services: [
      {
        title: 'Regulatory Strategy & Planning',
        description: 'Every product requires a unique regulatory pathway.',
        items: [
          'Target market regulatory analysis (India, US, EU, ASEAN)',
          'Pre-submission regulatory planning',
          'Regulatory intelligence research',
          'Risk assessment and mitigation planning',
        ],
      },
      {
        title: 'Dossier Preparation & Submission',
        description: 'Submission-ready dossiers for global markets.',
        items: [
          'CTD dossier preparation',
          'eCTD conversion and publishing',
          'Formulation development support',
          'Providing Tech Packs with Paper BE for availing Additional Product Permissions',
          'Post-approval variation management',
        ],
      },
    ],
    whyChoose: [
      '10+ years of regulatory affairs experience',
      'In-depth knowledge of CDSCO, US FDA, EU EMA, and WHO-PQ frameworks',
      'Proven track record: 100+ successful regulatory submissions',
      'Dedicated regulatory project manager for every client',
    ],
  },
  'gmp': {
    title: 'Revised Schedule M GMP Advisory',
    subtitle: 'From Compliance Gaps to Inspection Readiness.',
    heroImage: 'https://images.unsplash.com/photo-1705727210721-961cc64a6895?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1920',
    overviewTitle: 'India\'s Revised Schedule M',
    overview: 'Expert-led GMP advisory services for pharmaceutical manufacturers aligned to Revised Schedule M regulations.',
    services: [
      {
        title: 'GMP Gap Assessment',
        items: [
          'Facility assessment',
          'Documentation review',
          'Gap report with findings',
        ],
      },
      {
        title: 'SOP Development & Review',
        items: [
          'GMP SOPs for production, QC, QA',
          'Cleaning validation protocols',
          'Environmental monitoring SOPs',
        ],
      },
      {
        title: 'Audit Readiness & Mock Inspections',
        items: [
          'Mock GMP audits',
          'Simulated inspector walkthroughs',
          'Documentation review sessions',
        ],
      },
    ],
    whyChoose: [
      'Schedule M compliance specialists',
      'Practical, implementable solutions',
      'Mock audit preparation',
    ],
  },
  'who-gmp': {
    title: 'WHO GMP Certification Advisory',
    subtitle: 'International GMP Standards for Global Market Access',
    heroImage: 'https://images.unsplash.com/photo-1742189406399-a683d5650e06?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1920',
    overviewTitle: 'WHO GMP Pre-Qualification & Certification',
    overview: 'WHO GMP certification is essential for pharmaceutical manufacturers seeking to supply products to international markets, UN procurement agencies, and regulated markets worldwide. Pegasus Clinicare provides end-to-end advisory for WHO GMP certification readiness.',
    services: [
      {
        title: 'WHO GMP Certification Support',
        items: [
          'WHO-GMP Application under ONDLS with Profile Creation',
          'End to End Solution from State FDA Application till Final COPP approval',
          'WHO GMP gap assessment and compliance roadmap',
          'Documentation and quality system alignment to WHO standards',
          'Pre-qualification application support',
          'Mock WHO GMP inspections and audit readiness',
        ],
      },
      {
        title: 'International GMP Compliance',
        items: [
          'EU GMP Annex compliance advisory',
          'PIC/S GMP alignment support',
          'Quality Management System (QMS) enhancement',
        ],
      },
    ],
    whyChoose: [
      'Deep expertise in WHO GMP standards',
      'Proven track record with international certifications',
      'End-to-end support from gap assessment to certification',
    ],
  },
  'specialized': {
    title: 'Specialized Regulatory Consultation',
    subtitle: 'Expert Guidance for Niche Regulatory Domains',
    heroImage: 'https://images.unsplash.com/photo-1596462502278-27bfdc403348?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1920',
    overviewTitle: 'Specialized Regulatory Consulting',
    overview: 'Specialized regulatory consulting for medical devices, cosmetic, nutraceutical, and food products - ensuring compliant, accelerated market access.',
    services: [
      {
        title: 'Cosmetic Regulatory Services',
        items: [
          'CDSCO cosmetic import license applications',
          'Product registration and notification',
          'Ingredient compliance review',
          'Claims substantiation',
        ],
      },
      {
        title: 'Food & Nutraceutical Services',
        items: [
          'FSSAI license applications',
          'Product approval for novel ingredients',
          'Nutraceutical classification',
          'Labeling compliance',
        ],
      },
      {
        title: 'Medical Device Regulatory',
        items: [
          'CDSCO medical device registration',
          'Technical documentation preparation',
          'Post-market compliance support',
        ],
      },
      {
        title: 'Ayurvedic License Services',
        items: [
          'Ayurvedic manufacturing licence applications',
          'AYUSH regulatory submissions and approvals',
          'Ayurvedic proprietary medicine registration',
          'Herbal product labeling compliance',
        ],
      },
    ],
    whyChoose: [
      'CDSCO, FSSAI, and BIS expertise',
      'Cosmetic, food, and device regulatory specialists',
      'Label compliance review and claims substantiation',
    ],
  },
  'facility-design': {
    title: 'Facility Design & Project Consultancy',
    subtitle: 'Build Right the First Time.',
    heroImage: 'https://images.pexels.com/photos/11703173/pexels-photo-11703173.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    overviewTitle: 'Designing Facilities That Regulators Approve',
    overview: 'GMP-compliant pharmaceutical facility design and consultancy.',
    services: [
      {
        title: 'Facility Layout Planning',
        items: [
          'Master plan development',
          'Zoning and classification',
          'Room adjacency planning',
        ],
      },
      {
        title: 'HVAC & Cleanroom Engineering',
        items: [
          'Air handling unit (AHU) design',
          'Cleanroom classification (ISO 5-8)',
          'Pressure differential mapping',
        ],
      },
    ],
    whyChoose: [
      'Regulatory-compliant designs',
      'HVAC and cleanroom specialists',
      'Complete utilities planning',
    ],
  },
  'turnkey': {
    title: 'Turnkey Key Project',
    subtitle: 'One Partner, Zero Gaps.',
    heroImage: 'https://images.unsplash.com/photo-1669101283985-ab2b293923df?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1920',
    overviewTitle: 'Complete Facility Lifecycle Management',
    overview: 'Single point of accountability for your entire facility project - from design through commercial operations.',
    services: [
      {
        title: 'Pre-Project Planning',
        items: [
          'Scope definition',
          'Budget planning',
          'Regulatory requirements mapping',
        ],
      },
      {
        title: 'Qualification & Validation',
        items: [
          'DQ, IQ, OQ, PQ protocols',
          'Cleaning validation',
          'Process validation',
        ],
      },
    ],
    whyChoose: [
      'End-to-end project management',
      'On-time delivery',
      'Single point of accountability',
    ],
  },
  'drug-sourcing': {
    title: 'Global Drug Sourcing',
    subtitle: 'Hard-to-Source Reference Drugs.',
    heroImage: 'https://images.unsplash.com/photo-1576669801838-1b1c52121e6a?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1920',
    overviewTitle: 'Precision Drug Procurement',
    overview: 'Procurement of innovator and reference drugs from regulated markets globally with complete supply chain documentation.',
    services: [
      {
        title: 'What We Source',
        items: [
          'FDA Reference Listed Drugs (RLDs)',
          'EMA reference products',
          'Innovator branded drugs',
          'Comparator drugs for clinical trials',
        ],
      },
      {
        title: 'Our Sourcing Process',
        items: [
          'Requirement evaluation',
          'Regulatory compliance assessment',
          'Sourcing & procurement',
          'Complete documentation package',
          'Cold-chain logistics',
        ],
      },
    ],
    whyChoose: [
      'Global sourcing networks in US, EU, UK, Japan',
      'Complete regulatory documentation',
      'Cold-chain logistics capability',
      '100% supply chain authenticity with full pedigree documentation',
    ],
  },
  // Keep old slugs as aliases for backward compatibility
  'regulatory-affairs': null,
  'cosmetic-food': null,
};
